import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { IntroducePage } from "@/modules/landings/introduce/IntroducePage";
import styled from "styled-components";
const IntroductionPageWrapper = styled.div.withConfig({
    componentId: "sc-af4dfd21-0"
})(_templateObject());
const IntroductionPage = ()=>{
    return /*#__PURE__*/ _jsx(IntroductionPageWrapper, {
        children: /*#__PURE__*/ _jsx(IntroducePage, {})
    });
};
export default IntroductionPage;
